import $ from 'jquery'
import template from 'lodash.template'
import AjaxList from '../../components/ajaxList'
import i18n from '../../utils/translate'

class Module {
  constructor ($module) {
    this.$container = $module.find('.js-access-list')
    this.$list = $module.find('.js-access-list-wrap')

    this.sectionTemplate = template($module.find('.js-access-section-template').html())
    this.$itemTemplateEl = $module.find('.js-access-item-template')
    this.itemTemplate = template(this.$itemTemplateEl.html())

    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find('.js-access-filter-form'),
      append: (response, replace) => {
        return this.replace(response)
      }
    })
  }

  replace (response) {
    this.$list.empty()

    if (!Object.keys(response.access).length) {
      this.$container.addClass('empty_list')
    } else {
      this.$container.removeClass('empty_list')

      const $content = $('<div>')

      for (const k in response.access) {
        if (!Object.prototype.hasOwnProperty.call(response.access, k)) {
          continue
        }

        const $section = $(this.renderSection(k))
        const $items = $('<div>')

        response.access[k].forEach((v) => {
          $items.append(this.renderItem(v))
        })

        $section.find('.accounts').append($items)
        $content.append($section)
      }

      this.$list.append($content)
    }
  }

  renderSection (value) {
    return this.sectionTemplate({
      section: i18n.gettext('access.role_' + value + '.title')
    })
  }

  renderItem (value) {
    return this.itemTemplate({
      user: value.user,
      canDelete: this.$itemTemplateEl.data('can-delete'),
      deleteUrl: this.$itemTemplateEl.data('delete-url')
        .replace(/_account_/, value.account)
        .replace(/_user_/, value.user)
    })
  }
}

$(function () {
  $('.js-account-access').each(function () {
    new Module($(this))
  })
})
